import { useEffect, useState } from 'react';

import { ClassNameMap } from '@mui/material/styles';

import { FilePreview } from '@vk-hr-tek/ui/FilePreview';
import { useInject } from '@vk-hr-tek/core/ioc';
import { Box } from '@vk-hr-tek/ui/Box';

import { useRole } from '@app/hooks';

import { AuthService } from '../../services';
import type { LogoIconVariants } from '../../types';

import { LogoEmptyIcon } from './LogoEmptyIcon';
import { useStyles } from './AuthSourceLogo.styles';
import { LogoEmptyIconText } from './LogoEmptyIconText';

interface AuthSourceLogoProps {
  variant?: LogoIconVariants;
  full?: boolean;
}

const getSizeClass = (variant: LogoIconVariants, classes: ClassNameMap) => {
  switch (variant) {
    case '40':
      return classes.icon40;
    case '48':
      return classes.icon48;
    case '72':
      return classes.icon72;
    case '80':
      return classes.icon80;
    default:
      return classes.icon48;
  }
};

export const AuthSourceLogo = ({
  variant = '48',
  full = false,
}: AuthSourceLogoProps) => {
  const { classes } = useStyles();
  const [role] = useRole();
  const authService = useInject(AuthService);

  const [error, setError] = useState<Error>();

  const sizeClass = getSizeClass(variant, classes);

  const loadDocument = async () => {
    const res = await authService.getAuthSourceLogo();

    return res.file;
  };

  useEffect(() => {
    setError(undefined);
  }, [role]);

  if (error) {
    return (
      <Box className={classes.fullErrorLogo}>
        <LogoEmptyIcon variant={variant} />
        {full && (
          <Box display="flex" alignItems="center">
            <LogoEmptyIconText variant={variant} />
          </Box>
        )}
      </Box>
    );
  }

  return (
    <div className={sizeClass}>
      <FilePreview onLoad={loadDocument} hideLoader onError={setError} />
    </div>
  );
};
